export default __webpack_public_path__ + "static/media/Cane2Sugar_07.d1b23a43.png";